import { Input as AntdInput } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import styled from 'styled-components';

const StyledInput = styled(AntdInput)`
  width: ${(props) => props.width || '100%'};
`;

/**
 * Primary UI component for user interaction
 */

const Input = ({ disabled, error, handleChange, isMobile, placeholder, width, ...props }) => {
  return (
    <StyledInput
      disabled={disabled}
      onChange={handleChange}
      placeholder={placeholder}
      size={isMobile && 'large'}
      status={error && 'error'}
      width={width}
      {...props}
    />
  );
};

Input.propTypes = {
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  handleChange: PropTypes.func,
  width: PropTypes.string,
  isMobile: PropTypes.bool,
};

Input.defaultProps = {
  disabled: false,
  error: false,
  isMobile: false,
};

export { Input };
